import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Slide,
} from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import { useState, useEffect, useContext } from "react";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Btn from "../../../../components/buttons/Btn";
import TableDefault from "../../../../components/grid/TableDefault";
import Tree from "../../../../components/tree/Tree";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { getViewLists } from "../../../../repositories/qerpapi/erp/faturamento/ClassificacaoServicoRepository";
import MaskService from "../../../../utils/mask/maskService";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import { IconButtonStyled } from "../styles/style";
import { notify } from "./../../../../utils/notify";

const ModalCategorias = ({
  open,
  setModalOpen,
  content = [],
  setContent = () => {},
  setArray = () => {},
  array = [],
  visualizationOnly = false,
  newBankMoviment = false,
  contentTypeBillID = "",
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const { setLoading } = useContext(ConciliacaoBancariaContext);
  const [addingLine, setAddingLine] = useState(false);
  const [selected, setSelected] = useState([]);
  const [accountsPlanList, setAccountsPlanList] = useState([]);
  const [rows, setRows] = useState(content || []);

  const [percentage, setPercentage] = useState("100,00");

  const handleAddCategoryItem = () => {
    if (!selected[0]) return notify("Nenhum item selecionado.");

    let success = true;
    setRows((current) => {
      if (
        !!current.find(
          (e) =>
            `${e.id}_${e.idcentronegocio}` ===
            `${selected[0].id}_${selected[0].idcentronegocio}`
        )
      ) {
        notify("Item já selecionado.");
        success = false;
        return [...current];
      }

      return [
        ...current,
        { ...selected[0], rateio: MaskService.removeMaskDecimal(percentage) },
      ];
    });

    if (!success) return;

    setSelected([]);
    setAddingLine(false);
  };

  const handleCancel = () => {
    setAddingLine(false);
    setSelected([]);
  };

  const handleClose = () => {
    setModalOpen(false);
    setAddingLine(false);
  };

  const handleAddCategory = () => {
    setAddingLine(true);
  };

  const deleteItem = (id, idcentronegocio) => {
    setRows((current) =>
      current.filter(
        (e) => `${e.id}_${e.idcentronegocio}` !== `${id}_${idcentronegocio}`
      )
    );
  };

  const handleAdd = () => {
    if (rows.length && MaskService.removeMaskDecimal(percentage) !== 0) {
      return notify("O total do rateio deve ser 100%.");
    }

    if (newBankMoviment) {
      setContent(rows);
      handleClose();
      return;
    }

    const arrayCopy = JSON.parse(JSON.stringify(array));

    const updatedRows = arrayCopy.map((obj) => {
      if (obj.typeBillID === contentTypeBillID) {
        if (!rows.length) {
          delete obj.category;
        } else {
          obj.category = rows;
        }
      }

      return obj;
    });

    setArray(updatedRows);
    setContent({});

    handleClose();
  };

  const COLUMNS_MODAL_CONCILIATION = [
    ...(!visualizationOnly
      ? [
          {
            label: "Remover",
            id: "remover",
            format: (item) => (
              <IconButton
                onClick={() => deleteItem(item.id, item.idcentronegocio)}
                children={<Delete />}
                size="small"
              />
            ),
          },
        ]
      : []),
    {
      label: "Código",
      id: "codigo",
    },
    {
      label: "Descrição",
      id: "descricao",
    },
    {
      label: "Rateio (%)",
      id: "rateio",
      format: (item) => {
        return MaskService.toMask(
          "decimal",
          parseFloat(item.rateio || 0.0).toFixed(2)
        );
      },
    },
  ];

  useEffect(() => {
    const rest =
      (rows.reduce((acc, current) => acc + current.rateio || 0, 0) - 100) * -1;

    setPercentage(MaskService.toMask("decimal", rest.toFixed(2)));
  }, [rows]);

  useEffect(() => {
    const rest =
      (rows.reduce((acc, current) => acc + current.rateio || 0, 0) - 100) * -1;

    if (MaskService.removeMaskDecimal(percentage) > rest)
      setPercentage(MaskService.toMask("decimal", rest.toFixed(2)));
  }, [percentage, rows]);

  useEffect(() => {
    if (!addingLine || accountsPlanList.length) return;

    async function getData() {
      try {
        setLoading(true);

        const callback = await getViewLists({
          empresa_cnpj: queryParams.empresa_cnpj,
          empresa_id: queryParams.empresa_id,
        });

        if (!callback.success)
          return notify("Centros de custos não encontrados.");

        setAccountsPlanList(
          callback.data.centrocustos.map((e) => ({
            ...e,
            filhos: e.planonegocios,
          }))
        );
      } catch (e) {
      } finally {
        setLoading(false);
      }
    }

    getData();
  }, [
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    setLoading,
    addingLine,
    accountsPlanList,
  ]);

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        children={
          <div style={{ display: "flex" }}>
            Categorias
            {!addingLine && (
              <div style={{ marginLeft: 15 }}>
                <IconButtonStyled
                  onClick={handleAddCategory}
                  size="small"
                  children={<Add />}
                  disabled={
                    rows.reduce(
                      (acc, current) => acc + parseFloat(current.rateio),
                      0
                    ) === 100 || visualizationOnly
                  }
                />
              </div>
            )}
          </div>
        }
      />
      <DialogContent>
        {addingLine ? (
          <Slide direction="right" in={true}>
            <div>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextFieldErp
                    value={percentage}
                    setValue={setPercentage}
                    mask="decimal"
                    label="Rateio (%)"
                  />
                </Grid>
                {selected[0]?.descricao && (
                  <Grid item xs={6}>
                    <TextFieldErp
                      value={selected[0]?.descricao || ""}
                      label="Selecionado"
                      disabled
                      variant="filled"
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Tree
                    branches={accountsPlanList}
                    action={(e) => setSelected([e])}
                  />
                </Grid>
              </Grid>
            </div>
          </Slide>
        ) : (
          // <Slide direction="left" in={true}>
          <div>
            <TableDefault values={rows} columns={COLUMNS_MODAL_CONCILIATION} />
          </div>
          // </Slide>
        )}
      </DialogContent>
      <DialogActions>
        {!visualizationOnly && (
          <Btn
            autoFocus
            onClick={addingLine ? handleAddCategoryItem : handleAdd}
            label={addingLine ? "Adicionar" : "Salvar"}
          />
        )}
        <Btn
          autoFocus
          onClick={addingLine ? handleCancel : handleClose}
          bgcolor="tertiary"
          label={addingLine ? "Cancelar" : "Fechar"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalCategorias;
